
import Vue from 'vue';
import i18n from '@/i18n';
import { Tooltip, Icon } from '@descomplica/vue-components';

export default Vue.extend({
  i18n,
  components: {
    Tooltip,
    Icon,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    clickHandler: {
      type: Function,
      required: true,
    },
  },
});
